import IdVerification from "./IdVerification";

export default IdVerification;
